import { render, staticRenderFns } from "./OrderIDField.vue?vue&type=template&id=6140bbd4&scoped=true"
import script from "./OrderIDField.vue?vue&type=script&lang=js"
export * from "./OrderIDField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6140bbd4",
  null
  
)

export default component.exports